export default __webpack_public_path__ + "611d7fa2cf6319c39053de9d4f14448b.png";